import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolRoleBot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1088_5800)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_1088_5800)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M3.3125 10.6641V2.8125H11.1641L13.9766 0H0.5V13.4766L3.3125 10.6641Z",
					fill: "currentColor",
					fillOpacity: .2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.6875 4.51407V12.1875H5.01404L2.20154 15H15.5V1.70157L12.6875 4.51407Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1094 5.50781H6.125V9.49219H10.1094V5.50781Z",
					fill: "currentColor",
					fillOpacity: .2
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1088_5800",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(0.5)"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_1088_5800",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(0.5)"
		})
	})] })]
});
export default SvgLolRoleBot;
